import {
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material'
import { ReactElement } from 'react'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'

import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import Loading from 'src/v3/components/loading'
import { selectRoles } from 'src/v3/settings/settings.slice'
import {
  selectClassID,
  selectCurrentStep,
  selectProgress,
  selectStreamItems,
  stepCompleted,
  steppedBackward,
  steppedForward,
} from '../classroom.slice'

export default (): ReactElement => {
  let dispatch = useAppDispatch()
  let classID = useAppSelector(selectClassID)
  let items = useAppSelector(selectStreamItems)
  let progress = useAppSelector(selectProgress)
  let currentStep = useAppSelector(selectCurrentStep)
  let roles = useAppSelector(selectRoles)
  let isAdmin = roles.includes('admin')

  let nextStep = () => {
    if (items[currentStep].type === 'title_screen') {
      axios
        .post('/api/v2/classroom/stream-event/title-screen', {
          classID,
          titleScreenID: items[currentStep]?.id,
          status: 'completed',
        })
        .then(() => {
          dispatch(stepCompleted())
          dispatch(steppedForward())
        })
    }
    if (items[currentStep].type === 'video') {
      // Video dispatches completion event on its own
      dispatch(steppedForward())
    }
    if (items[currentStep].type === 'text_content') {
      axios
        .post('/api/v2/classroom/stream-event/text-content', {
          classID,
          textContentID: items[currentStep]?.id,
          status: 'completed',
        })
        .then(() => {
          dispatch(stepCompleted())
          dispatch(steppedForward())
        })
    }
  }

  return (
    <>
      <Stepper
        activeStep={currentStep}
        orientation="vertical"
        style={{ backgroundColor: 'inherit' }}
      >
        {progress.map((_, i) => (
          <Step key={i}>
            <StepLabel>{items?.[i]?.name}</StepLabel>
            <StepContent>
              <Typography>{items?.[i]?.description}</Typography>
              <div>
                <div>
                  <Button
                    disabled={currentStep === 0}
                    onClick={() => dispatch(steppedBackward())}
                  >
                    Back
                  </Button>
                  {currentStep !== progress.length - 1 && (
                    <Button
                      disabled={
                        !isAdmin &&
                        (!progress.length ||
                          (progress[currentStep]?.type !== 'textContent' &&
                            progress[currentStep]?.type !== 'titleScreen' &&
                            progress[currentStep]?.status !== 'completed'))
                      }
                      variant="contained"
                      color="primary"
                      onClick={nextStep}
                      endIcon={isAdmin ? <AdminPanelSettingsIcon /> : null}
                    >
                      Next
                    </Button>
                  )}
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <Loading entities={['fulfilled']} loading={progress.length === 0} />
    </>
  )
}
